<h2 mat-dialog-title class="dialog-title">
  <span class="badge"><mat-icon>more_time</mat-icon></span>
  <span class="text">
    <span translate="CALLS.RETENTION_EXTENSION_REQUEST.DIALOG_TITLE"></span>
    <span class="subtitle">
      <span class="call-name mask-call-name">{{ data.callName }}</span>
      <span class="separator" aria-hidden="true">•</span>
      <span class="call-date">{{ 'CALLS.RETENTION_EXTENSION_REQUEST.MEETING_HELD' | translate: { date: (callDate | date: dateTimeFormat) } }}</span>
    </span>
  </span>
  <button mat-icon-button [mat-dialog-close]="false" [disabled]="isSubmitting" [attr.aria-label]="'COMMON.CLOSE' | translate">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <p class="description" translate="CALLS.RETENTION_EXTENSION_REQUEST.DIALOG_DESCRIPTION"></p>

  @if (data.availableExtensionsInDays.length === 0) {
    <p class="notice" translate="CALLS.RETENTION_EXTENSION_REQUEST.NONE_AVAILABLE"></p>
  } @else {
    <div class="options" role="radiogroup">
      @for (days of extensionsInDays; track days) {
        <button
          mat-stroked-button
          type="button"
          role="radio"
          class="option"
          [attr.aria-checked]="selectedExtensionInDays === days"
          [class.selected]="selectedExtensionInDays === days"
          [disabled]="!isAvailable(days)"
          (click)="select(days)"
        >
          {{ (days === 1 ? 'CALLS.RETENTION_EXTENSION_REQUEST.DAY' : 'CALLS.RETENTION_EXTENSION_REQUEST.DAYS') | translate: { count: days } }}
        </button>
      }
    </div>
    @if (hasUnavailableExtensions) {
      <p class="hint" translate="CALLS.RETENTION_EXTENSION_REQUEST.UNAVAILABLE_HINT"></p>
    }
  }

  <dl class="dates">
    <div class="date">
      <dt translate="CALLS.RETENTION_EXTENSION_REQUEST.CURRENT_EXPIRY"></dt>
      <dd>{{ currentSoftDeletionDate | date: dateTimeFormat }}</dd>
    </div>
    @if (resultingSoftDeletionDate; as resultingDate) {
      <div class="date resulting">
        <dt translate="CALLS.RETENTION_EXTENSION_REQUEST.NEW_EXPIRY"></dt>
        <dd>{{ resultingDate | date: dateTimeFormat }}</dd>
      </div>
    }
  </dl>
  <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button [mat-dialog-close]="false" [disabled]="isSubmitting" translate="COMMON.CANCEL"></button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="selectedExtensionInDays === null || isSubmitting"
    (click)="submit()"
    translate="CALLS.RETENTION_EXTENSION_REQUEST.SUBMIT"
  ></button>
</mat-dialog-actions>
